module.exports = __webpack_public_path__ + "a33808e1480bbdc1273cce84ed5c288c.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/mdi/fonts/materialdesignicons-webfont.ttf?v=2.2.43
// module id = 956
// module chunks = 1